import { render, staticRenderFns } from "./versionsTable.vue?vue&type=template&id=274e4128&scoped=true&"
import script from "./versionsTable.vue?vue&type=script&lang=js&"
export * from "./versionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e4128",
  null
  
)

export default component.exports